import { render, staticRenderFns } from "./modalEditMasterFreight.vue?vue&type=template&id=9692593a&scoped=true&"
import script from "./modalEditMasterFreight.vue?vue&type=script&lang=js&"
export * from "./modalEditMasterFreight.vue?vue&type=script&lang=js&"
import style0 from "./modalEditMasterFreight.vue?vue&type=style&index=0&id=9692593a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9692593a",
  null
  
)

export default component.exports